import { Formik } from "formik";
import CustomTabMenu from "../component/CustomTabMenu";
import PhanHeXuatKho from "../phan-he-xuat-kho/PhanHeXuatKho";
import { WAREHOUSE_ID } from "../utils/Constant";
import { danhSachTabKhoNhaThuoc } from "./Constant";

export const TuongTacThuoc: React.FC = () => {

  return (
    <Formik<any> initialValues={{}} onSubmit={() => { }}>
      {/* <CustomTabMenu
      childrenTab={true}
      danhsachTabs={danhSachTabKhoNhaThuoc}
      className="spaces pl-0"
    /> */}
      <PhanHeXuatKho
        warehouseId={WAREHOUSE_ID.TUONG_TAC_THUOC}
        titleGrid="Danh sách tương tác thuốc"
        className="h-bang-ds-phieu-ttthuoc"
      />
    </Formik>
  );
};

export default TuongTacThuoc;
